var $0f1d3818d9be1914$exports = {};
$0f1d3818d9be1914$exports = {
    "clear": `Skaidrus`,
    "invalid": `(netinkama)`,
    "loading": `\u{12E}keliama...`,
    "noResults": `Be rezultat\u{173}`,
    "valid": `(galioja)`
};


export {$0f1d3818d9be1914$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
